






























































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import {Action} from "vuex-class";
import {SmsDetailInfoItem} from "@/store/sms/statistic/types";
import {colorClassByStatus, formatAsJson} from "@/utils/page-utils";
import {notifyError, notifySuccess} from "@/utils/notify-helper";
import {dateFilter} from "@/utils/date-util";
import {getTranslatedParams} from "@/utils/notify-utils";
import {MsgTransports} from "@/store/types";
import {ActionLog} from "@/store/auth/types";
import {InputWings, TextareaWings} from "wings-ui-components"

Component.registerHooks([
  'beforeRouteLeave',
]);
@Component({
  components: {InputWings, TextareaWings},
  filters: {dateFilter},
  methods: {colorClassByStatus, formatAsJson}
})
export default class SmsDetailInfo extends Vue {
  @Action("getSmsStatisticDetailInfo") actionGetSmsStatisticDetailInfo: any;
  @Action("resendSmsMessage") actionResendMessage: any;
  @Action("actionLog") actionLog: any;

  defaultInfo(): SmsDetailInfoItem {
    return {
      recipient: "",
      region: "",
      country: "",
      originator: "",
      message_parts: null,
      message: "",
      error_code: null,
      error_description: "",
      service_provider: null,
      transport_message_id: "",
      status: "",
      message_category: "",
      partner: "",
      external_id: null,
      partner_user_login: "",
      id: "",
      partner_price: null,
      provider_price: null,
      operator: "",
      broker_account_login: null,
      template_id: null,
      bulk_id: "",
      module: "",
      defer_date: null,
      sent_date: null,
      expire_date: null,
      connection_type: null,
      parent_message_id: null,
      parent_message_transport: null,
    };
  }

  private messageInfo = this.defaultInfo();
  private transport = MsgTransports.SMS;
  private logObject: ActionLog = {};

  async created() {
    if (this.$route.params.id) {
      try {
        this.logObject = {
          action_page: this.$route.meta.msgKey,
          action: "Viewing",
          action_status: "success",
          object_type: "Message",
          addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
        }
        await this.actionGetSmsStatisticDetailInfo(this.$route.params.id).then((data: any) => {
          this.messageInfo = Object.assign({}, this.messageInfo, data);
        });
        await this.actionLog(this.logObject);
      } catch (err) {
        await this.actionLog({...this.logObject, action_status: "failed"});
      }
    }
  }

  back(): void {
    this.$router.push('/sms/detail/');
  }

  get isShowFinanceInfo(): boolean {
    let value: string = localStorage.getItem("show-finance-info") || "true";
    return JSON.parse(value)
  }

  async resend(): Promise<void> {
    try {
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Resending",
        action_status: "success",
        object_type: "Message",
        addititional_info: getTranslatedParams({channel: this.transport, message_id: this.$route.params.id})
      }
      await this.actionResendMessage(this.$route.params.id);
      await this.actionLog(this.logObject);
      notifySuccess(this.$t('dialog.resend').toString())
    } catch (err) {
      await this.actionLog({...this.logObject, action_status: "failed"});
      notifyError(err)
    }
  }
}
